module.exports = __webpack_public_path__ + "img/pr-16.e55fb5c4.png";